// Plugin
import Swiper from 'swiper/bundle';
import { Navbar, Modal } from 'bootstrap';
import WOW from 'wow.js';
import "@lottiefiles/lottie-player";

new WOW().init();

// Navbar
window.addEventListener('scroll', () => {
    let nav = document.querySelector('.navbar');
    if(window.scrollY > 0){
        nav.classList.add('top');
    }else{
        nav.classList.remove('top');
    }
})

let navDropdown = document.querySelector('.nav-dropdown');
navDropdown.addEventListener('click', () => {
    navDropdown.classList.toggle('show');
})
document.querySelector('body').addEventListener('click', (e) => {
    if(!e.target.closest('.nav-dropdown')){
        navDropdown.classList.remove('show');
    }
});
let btnToggleNav = document.querySelector('.btn-toggle-nav');
let allNavLinks = document.querySelectorAll('.nav-link');
allNavLinks.forEach(navLink => {
    navLink.addEventListener('click', (e) => {
        // Close Nav
        if(window.innerWidth < 1200){
            btnToggleNav.click();
        }
        // Scroll to Section
        let id = navLink.querySelector('a').getAttribute('href');
        e.preventDefault()
        let timeout = window.innerWidth < 1200 ? 500 : 0;
        setTimeout(() => {
            window.scrollTo({
                top: document.querySelector(id).offsetTop - document.querySelector('.navbar').offsetHeight,
                behavior: 'smooth'
            })
        }, timeout)

    })
})

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

//Page Hash
let hash = window.location.hash;
if(hash){
    setTimeout(() => {
        window.scrollTo({
            top: document.querySelector(hash).offsetTop - document.querySelector('.navbar').offsetHeight,
            behavior: 'smooth'
        })
    }, 1000);
}

//Page Texture
window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelector(':root').style.setProperty('--overlay-texture-mode', 'multiply')
        document.querySelector(':root').style.setProperty('--overlay-texture-opacity', '0.4')
    }, 1)
})

// Swiper
let headerSwiper = new Swiper(".header-swiper", {
    autoplay: {
        delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
        1200: {
            slidesPerView: 1.7,
            spaceBetween: 16
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 14
        },
        576: {
            slidesPerView: 1.3,
            spaceBetween: 12
        },
    },
    speed: 1000,
    centeredSlides: true,
    rewind: true,
    pagination: {
    el: ".header-swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.header-swiper-right',
        prevEl: '.header-swiper-left',
    },
});

// Location Tabs
let locationTabs = document.querySelector('.location-card').querySelectorAll('.tab');
let locationInfos = document.querySelector('.location-card').querySelectorAll('.card-info');
locationTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
        locationTabs.forEach(tab => {
            tab.classList.remove('active');
        })
        tab.classList.add('active');
        
        locationInfos.forEach(info => {
            info.classList.remove('active');
        })
        locationInfos[index].classList.add('active');
    })
})

//Video
window.addEventListener('load', () => {
    let video_btn = document.querySelector('.fixed-video');
    if(video_btn !== null){
        video_btn.click();
    }
})
$('#videoModal').on('shown.bs.modal', function () {
    let videoUrl = "https://www.youtube.com/embed/" + $('#videoModal').data('id') + "?autoplay=1&mute=0&enablejsapi=1";
    $('#videoModal iframe').attr('src', videoUrl);
})
$('#videoModal').on('hidden.bs.modal', function () {
    $('#videoModal iframe').attr('src', "https://www.youtube.com/embed/");
})